import { FC, memo } from 'react';

import { useStickyRowMenu } from '../../Table.hooks';
import { Root } from './HeaderActionMenuCell.styles';
import { HeaderActionMenuCellProps } from './HeaderActionMenuCell.types';

export const HeaderActionMenuCell: FC<HeaderActionMenuCellProps> = memo((props) => {
    const { bordered, sticky } = props;

    const { setCellRef, isRowMenuStickyActive } = useStickyRowMenu(Boolean(sticky));

    return (
        <Root ref={setCellRef} $bordered={bordered} $sticky={sticky} $isRowMenuStickyActive={isRowMenuStickyActive} />
    );
});
